import { Bank } from '../types';

export const MOCK_BANKS: readonly Bank[] = [
  {
    id: '1',
    name: 'Бакай банк',
    logo_src: 'https://i.banks.kg/8426/bakai-square.png',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  },
  {
    id: '2',
    name: 'Айыл Банк',
    logo_src: 'https://i.banks.kg/322/aiylbanklogo.jpg',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  },
  {
    id: '3',
    name: 'Оптима банк',
    logo_src: 'https://i.banks.kg/308/optimabank.png',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  },
  {
    id: '4',
    name: 'Демир Кыргыз Интернэшнл Банк',
    logo_src: 'https://i.banks.kg/307/demirbanklogo.png',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  }
] as const;
